import history from "@assets/web-v3-images/icons/history-icon.png";
import { useTranslation } from "react-i18next";

const HistoryIcon = ({ width = 112, height = 112, className = "", onClick }) => {
  const { t } = useTranslation();
  return (
    <div
      className={`intro-tour-home__step-12 btn-click-active flex items-center justify-center relative size-17.5 md:size-28 ${className}`}
      onClick={onClick}
    >
      {/* Bóng 2 lớp giống icon Shwe Hours: lớp sát chân gọn + đậm để tách hình
          khỏi nền cam, lớp dưới toả rộng tạo độ sâu. Gộp trong MỘT utility
          `filter-[...]` vì hai class `drop-shadow-*` sẽ đè lên nhau (cùng ghi
          vào --tw-drop-shadow) chứ không cộng dồn. */}
      <img
        src={history}
        alt=""
        width={width}
        height={height}
        className="filter-[drop-shadow(0_1px_1.5px_rgba(90,17,6,0.55))_drop-shadow(0_5px_9px_rgba(90,17,6,0.45))]"
      />
      <p className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1 w-max whitespace-nowrap text-sm md:text-xl font-extrabold">
        <span
          aria-hidden="true"
          className="absolute inset-0 px-0.5 md:px-1 text-transparent bg-linear-to-b from-[#FF9409] to-[#F74A00] bg-clip-text [-webkit-text-stroke:5px_transparent] [text-shadow:2px_2px_4px_#B7220D]"
        >
          {t("history.history")}
        </span>
        <span className="relative inline-block px-0.5 md:px-1 text-transparent bg-linear-to-b from-[#FBF5DA] from-57% to-[#FDEFB0] bg-clip-text">
          {t("history.history")}
        </span>
      </p>
    </div>
  );
}

export default HistoryIcon;
